import { useEffect, useRef } from 'react';

type Callback<T = unknown> = (args?: T) => void;
export function useInterval<T>(callback: Callback<T>, delay: number): Callback {
  const cb = useRef<Callback<T>>();
  const id = useRef<number>();
  useEffect(() => {
    cb.current = callback;
  }, [callback]);
  useEffect(() => {
    const handler = (args: T) => cb.current && cb.current(args);
    id.current = window.setInterval(handler, delay);
    return () => window.clearInterval(id.current);
  }, [delay]);
  return () => window.clearInterval(id.current);
}
